module.exports = __webpack_public_path__ + "static/media/node-js-logo.14051f0d.svg";